//routes to particular page

export const OPERATOR_PATH = "/operator";
export const LOGIN_PATH = "/login";
export const MONTHLY_PAYMENT= "/monthly-payment";
export const ANNUAL_PAYMENT= "/annual-payment";
export const OTP_PAYMENT= "/otp-payment";
export const SUCCESS_PAYMENT= "/success-payment";
export const FAILED_PAYMENT= "/failed-payment";
export const TERMS_AND_CONDITIONS = "/terms-and-conditions";


